import {
	CERULEO_SELECTED_SCAN_EVENT,
	CERULEO_SELECTED_SCAN_PAYLOAD_EVENT,
	RuntimeSelectedScan,
	SelectedScanPayload,
} from "./selectedScanRuntime";

export interface CeruleoRuntimeApi {
	getSelectedScan(): RuntimeSelectedScan | null;
	getSelectedScanPayload(): SelectedScanPayload | null;
	onSelectedScanChange(
		listener: (selectedScan: RuntimeSelectedScan | null) => void,
	): () => void;
	onSelectedScanPayloadChange(
		listener: (payload: SelectedScanPayload | null) => void,
	): () => void;
}

declare global {
	interface Window {
		Ceruleo?: CeruleoRuntimeApi;
	}
}

export function createCeruleoRuntimeApi(): CeruleoRuntimeApi {
	return {
		getSelectedScan() {
			return window.__CERULEO_SELECTED_SCAN__ ?? null;
		},
		getSelectedScanPayload() {
			return window.__CERULEO_SELECTED_SCAN_PAYLOAD__ ?? null;
		},
		onSelectedScanChange(listener) {
			const handler = (event: Event) => {
				listener((event as CustomEvent<RuntimeSelectedScan | null>).detail);
			};

			window.addEventListener(
				CERULEO_SELECTED_SCAN_EVENT,
				handler as EventListener,
			);
			return () =>
				window.removeEventListener(
					CERULEO_SELECTED_SCAN_EVENT,
					handler as EventListener,
				);
		},
		onSelectedScanPayloadChange(listener) {
			const handler = (event: Event) => {
				listener((event as CustomEvent<SelectedScanPayload | null>).detail);
			};

			window.addEventListener(
				CERULEO_SELECTED_SCAN_PAYLOAD_EVENT,
				handler as EventListener,
			);
			return () =>
				window.removeEventListener(
					CERULEO_SELECTED_SCAN_PAYLOAD_EVENT,
					handler as EventListener,
				);
		},
	};
}

export function ensureCeruleoRuntimeApi(): CeruleoRuntimeApi {
	if (!window.Ceruleo) {
		window.Ceruleo = createCeruleoRuntimeApi();
	}
	return window.Ceruleo;
}
